import { Email } from "@mui/icons-material";
import { IconAndLabelColumnHeader, TableAvatar } from "../../utils/dataGrid";
import Translate from "../../utils/Translate";

const commonProps = {
  flex: 1,
  minWidth: 150,
};

export const renderHeader = (translationKey, icon) => {
  const headerText = Translate.get(translationKey);
  return (
    <IconAndLabelColumnHeader icon={icon} label={headerText} />
    // TODO: ska man bara visa tooltip om texten "klipper"?
    // <Tooltip title={headerText}>
    //   <div className="stdFlexLeft">
    //     {icon}
    //     <div>{headerText}</div>
    //   </div>
    // </Tooltip>
  );
};
export const textColumn = (dataField, icon, translationKey) => ({
  ...commonProps,
  field: dataField,
  type: "text",
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
});

export const numberColumn = (dataField, icon, translationKey) => ({
  ...commonProps,
  field: dataField,
  type: "number",
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
});

export const getterColumn = (columnName, getter, icon, translationKey) => ({
  ...commonProps,
  field: columnName,
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
  valueGetter: getter,
});

export const dateColumn = (dataField, icon, translationKey) => ({
  ...commonProps,
  field: dataField,
  type: "date",
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
  valueGetter: (value, row, column, apiRef) => value && new Date(value),
});

export const booleanColumn = (dataField, icon, translationKey) => ({
  ...commonProps,
  field: dataField,
  type: "boolean",
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
});

export const formattedColumn = (dataField, icon, translationKey, formattingFunction) => ({
  ...commonProps,
  field: dataField,
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
  valueFormatter: (value, row, column, apiRef) => value && formattingFunction(value),
});

export const avatarColumn = (
  dataField,
  secondaryDataField,
  avatarUrlField,
  icon,
  translationKey,
  variant = "circular",
) => ({
  ...commonProps,
  field: dataField,
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
  renderCell: (params) => (
    <TableAvatar
      src={avatarUrlField ? params.row[avatarUrlField] : undefined}
      title={params.row[dataField]}
      subtitle={secondaryDataField && params.row[secondaryDataField]}
      variant={variant}
    />
  ),
});

export const customCellColumn = (dataField, icon, translationKey, renderCell, valueGetter, valueFormatter) => ({
  ...commonProps,
  field: dataField,
  type: "text",
  headerName: Translate.get(translationKey),
  renderHeader: () => renderHeader(translationKey, icon),
  renderCell,
  valueGetter,
  valueFormatter
});
